import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../../services/auth/auth.service'
import { Request } from '../../../../model/auth/request';
import { HttpErrorResponse } from '@angular/common/http';
import { SystemParametersService } from 'src/app/services/systemParameter/system-parameters.service';
import { SystemParameters } from 'src/app/model/systemParameters/system-parameters';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    username: string = '';
	password: string = '';

    mfaTypes: any = [];
    selectedMfa:any;
	verificationCode: string = '';
	qrCode : string = '';
	isSignedin = false;

	toTpVerification = false;

	error: string = '';
	params: any = ["WEBERF_ALERT_LOGIN_PG"];
	systemParameters: SystemParameters[] = [];

	constructor(private route: ActivatedRoute, private router: Router, private authService: AuthService,private systemParameterService: SystemParametersService) {}

	ngOnInit() {
		this.isSignedin = this.authService.isUserSignedin();

		if(this.isSignedin) {
			this.router.navigateByUrl('home');
		} else {
			this.systemParameterService
				.getHeaderDetails(this.params)
				.subscribe(
				(responseP: any) => {
					this.systemParameters = responseP.result;
				},
				(error: HttpErrorResponse) => {
					alert(error.error.reason);
				}
				);
		}
	}

	doSignin() {
		const pass = document.getElementById("password") as HTMLInputElement;
		if((this.selectedMfa == null || this.selectedMfa == undefined) && (this.verificationCode == null || this.verificationCode == '' || this.verificationCode == undefined)){
			this.password = pass.value;
		}
		if(this.username !== '' && this.username !== null && this.password !== '' && this.password !== null) {
			const request: Request = { 
				userName: this.username, 
				userPwd: this.password,userType: 'W',
				verificationKey: this.verificationCode,
        		selectedMFA: this.selectedMfa != null ? this.selectedMfa.type.parameterCode : null
			};

			this.authService.signin(request).subscribe((result)=> {
				if (this.authService.getUserMustAcceptTermsOfUse()){this.router.navigate(['/acceptTermsOfUse']);}
				//TODO
				this.toTpVerification = result.result.provideVerifyCode;
				if(this.toTpVerification){
					this.mfaTypes = result.result.mfas;
					this.qrCode = result.result.qrCode;
					if(this.mfaTypes.length == 1){
						this.selectedMfa = this.mfaTypes[0];
					} else if(request.selectedMFA == null){
						this.selectedMfa = null;
					}
				} else {
					if (this.authService.getUserMustAcceptTermsOfUse()){
						this.router.navigate(['/acceptTermsOfUse']);
					}else{
						this.authService.checkPasswordExpired().subscribe(
							(response: any) => {
							// check if password is expired
							if(response){
								alert("Please change password.");
								this.authService.setPassExp('true');
								this.router.navigateByUrl('changePW');
							}else{
								this.router.navigateByUrl('home');
							}
							},
							(error: HttpErrorResponse) => {
							if(error.status == 200){
								alert(error.error.text);
							}else{
								alert(error.error);
							}
							}
						);
						this.router.navigateByUrl('home');
					}
				}
			},
			(error: HttpErrorResponse) => {
			  this.error = error.error.reason;
			});
		} else {
			this.error = 'Invalid Credentials';
		}
	}

	clearQrCode(){
		this.qrCode = '';
	}
	
    signInWith(type: any) {
		this.selectedMfa = type;
    	this.doSignin();
    }
}
